/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {LocaleAdapterInterface} from '@/services/language/types';
import store from '@/store';

/**
 * Local storage persistence locale adapter.
 *
 * @implements LocaleAdapterInterface
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export class PersistenceAdapter implements LocaleAdapterInterface {
    /**
     * Language setter.
     *
     * @param locale
     */
    public async setLocale(locale: string): Promise<void> {
        await store.dispatch('settingsModule/updateLanguage', locale);
    }
}
